<template>
	<div class="booker-delivery-summary">
		<ButtonCustom rounded="xl" class="booker-delivery-summary__back" @click="tab = 'delivery'">
			<div class="booker-delivery-summary__back-content">
				<GlobalIcon class="booker-delivery-summary__" name="arrow-left" :height="14" /> {{ $t('components.booker.car_delivery.back') }}
			</div></ButtonCustom
		>
		<div class="booker-delivery-summary__container">
			<div class="booker-delivery-summary__title-return">
				<div class="booker-delivery-summary__title">{{ $t('components.booker.car_delivery.summary') }}</div>
				<ButtonIcon class="booker-delivery-summary__close" @click="isDeliveryCarModalOpen = false">
					<GlobalIcon name="close-bold" :height="9"></GlobalIcon>
				</ButtonIcon>
			</div>
			<div class="booker-delivery-summary__sections">
				<div v-for="(section, i) in sections.filter((s) => s.isVisible)" :key="i" class="booker-delivery-summary__section">
					<div class="booker-delivery-summary__icon">
						<GlobalIcon :name="section.icon" :height="20"></GlobalIcon>
					</div>
					<div class="booker-delivery-summary__content">
						<div class="booker-delivery-summary__label">{{ section.label }}</div>
						<div v-if="section.value" class="booker-delivery-summary__value">{{ section.value }}</div>
						<div v-else class="booker-delivery-summary__value">
							<v-progress-circular indeterminate :size="18" :width="2" color="var(--primary-color)"></v-progress-circular>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="booker-delivery-summary__button-container">
			<ButtonPrimary class="booker-delivery-summary__button" @click="goToDates">{{
				$t('components.booker.car_delivery.choose_dates')
			}}</ButtonPrimary>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { EBookerLocationType } from '@/data/bookerData'
const isDeliveryCarModalOpen = inject<Ref<boolean>>('isDeliveryCarModalOpen')!

const bookerState = inject<Ref<IBookerState>>('bookerState')!
const tab = inject<Ref<string>>('tab')!
const isLocationMenuOpen = defineModel<boolean>()
const localePath = useLocalePath()

defineProps<{
	type: EBookerLocationType
}>()
const router = useRouter()
const $t = useI18n().t

const sections = computed(() => {
	return [
		{
			icon: 'routing',
			label: bookerState.value.otherEndLocation
				? $t('components.booker.car_delivery.address_delivery')
				: $t('components.booker.car_delivery.address_delivery_collection'),
			value: bookerState.value.selectedLocations.start?.city
				? `${bookerState.value.selectedLocations.start?.city}, ${bookerState.value.selectedLocations.start?.name}`
				: bookerState.value.selectedLocations.start?.name,
			isVisible: bookerState.value.selectedLocations.start?.name,
		},
		{
			icon: 'dollar',
			label: bookerState.value.otherEndLocation
				? $t('components.booker.car_delivery.address_delivery_cost')
				: $t('components.booker.car_delivery.address_delivery_collection_cost'),
			value:
				bookerState.value.deliveryCosts.start !== null
					? !bookerState.value.otherEndLocation
						? formatPrice(bookerState.value.deliveryCosts.start * 2)
						: formatPrice(bookerState.value.deliveryCosts.start)
					: null,
			isVisible:
				bookerState.value.selectedLocations.start?.name &&
				bookerState.value.selectedLocations.start?.placeID &&
				bookerState.value.selectedLocations.start?.isDelivery,
		},
		{
			icon: 'routing',
			label: $t('components.booker.car_delivery.return_address'),
			value: bookerState.value.selectedLocations.end?.city
				? `${bookerState.value.selectedLocations.end?.city}, ${bookerState.value.selectedLocations.end?.name}`
				: bookerState.value.selectedLocations.end?.name,
			isVisible: bookerState.value.otherEndLocation && bookerState.value.selectedLocations.end?.name,
		},
		{
			icon: 'dollar',
			label: $t('components.booker.car_delivery.return_address_cost'),
			value: bookerState.value.deliveryCosts.end !== null ? formatPrice(bookerState.value.deliveryCosts.end) : null,
			isVisible:
				bookerState.value.otherEndLocation &&
				bookerState.value.selectedLocations.end?.placeID &&
				bookerState.value.selectedLocations.end?.isDelivery,
		},
	]
})

// const sections = ref()

const goToDates = () => {
	isLocationMenuOpen.value = false
	isDeliveryCarModalOpen.value = false
	bookerState.value.isStartLocationMenuOpen = false
	bookerState.value.isEndLocationMenuOpen = false
	router.push(localePath({ hash: '#date' }))
	bookerState.value.isStartDateMenuOpen = true
}
</script>

<style lang="scss">
@import './DeliveryCarSummary';
</style>
